var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',[_c('router-view',{staticClass:"fill-height"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }